import { WidgetDataType, setWidgetType, widget } from '@sitecore-search/react';
import { SearchResultsComponent } from './SearchResultsComponent';

const SearchResultsWidget = widget(
  SearchResultsComponent,
  WidgetDataType.SEARCH_RESULTS,
  'product'
);

setWidgetType(WidgetDataType.SEARCH_RESULTS, {
  component: SearchResultsComponent,
  options: {
    visibility: {
      threshold: Number(process.env.NEXT_PUBLIC_SEARCH_VISIBILITY_THRESHOLD ?? 0) / 100, // Convert % to decimal
    },
  },
});

export default SearchResultsWidget;
